import { VFC, useEffect, useLayoutEffect } from 'react'
import { AuthState, LoadingPlaceholder, SupportAccount, indexTsgInstances } from '@sparky/framework'
import { CommonStoreState, IndexedSupportAccounts, StateRef, stateRef, useStoreReducer } from '../../activation/store'
import { LG_BASE_FONT_SIZE, TSG_NONE } from '../../common/constants/GlobalConstants'
import reducer from '../../activation/reducer'
import ScreenHeader from '../components/ScreenHeader'
import useLightModeOverride from '../../common/hooks/useLightModeOverride'
import { updateStateProps } from '../../activation/actions'
import ProfileActivationForm from '../components/ProfileActivationForm'

export type ProfileActivationProps = {
  state: CommonStoreState
}

const getIndexedSupportAccounts = (supportAccountIds?: SupportAccount[]) => {
  const accounts = Array.from(supportAccountIds || []) // clone
  const accountMap = new Map<string | number, SupportAccount>()
  for (const acc of accounts) {
    accountMap.set(+acc.accountid, acc)
    accountMap.set(String(acc.accountid), acc)
  }
  Object.defineProperties(accounts, {
    get: {
      value: accountMap.get.bind(accountMap)
    },
    isLoaded: {
      value: Array.isArray(supportAccountIds)
    },
    supportAccountIds: { value: supportAccountIds },
  })
  return accounts as IndexedSupportAccounts
}
const DEFAULT_EMPTY_INSTANCES = indexTsgInstances([], '')
const getUpdatedState = (auth: AuthState, stateRef?: StateRef): CommonStoreState => {
  const { tsg_id, apps, user, tsgs, instances: globalInstances } = auth
  const selectedTsgId = stateRef?.current.tsg?.id
  const tsg = (selectedTsgId === TSG_NONE.id && TSG_NONE) ||
    (selectedTsgId && tsgs.get(selectedTsgId)) || undefined
  const currentSupportAccounts = stateRef?.current.supportAccounts
  const userSupportAccount = user?.supportAccountIds
  const supportAccounts = userSupportAccount === (currentSupportAccounts as any)?.supportAccountIds ? currentSupportAccounts : getIndexedSupportAccounts(user?.supportAccountIds)
  const loadingTsg = Boolean(tsg && tsg_id !== selectedTsgId)
  const instances = !selectedTsgId ? DEFAULT_EMPTY_INSTANCES : tsg_id === selectedTsgId ? globalInstances : (
    stateRef?.current.instances || indexTsgInstances([], selectedTsgId)
  )
  return {
    globalTsgId: tsg_id,
    tsg,
    tsgs,
    apps,
    supportAccounts,
    instances,
    loadingTsg,
    loading: !(apps?.length && (supportAccounts as any)?.isLoaded),
  } as CommonStoreState
}
const ProfileActivationContainer: VFC<{ auth: AuthState, location: { pathname: string } }> = ({ auth, location }) => {
  const { access, user } = auth
  const state = useStoreReducer(reducer, {}, () => {
    return getUpdatedState(auth)
  })
  useLightModeOverride(true) // temp before dark mode is fully supported
  useLayoutEffect(() => { // TODO: hacks
    const appClassList = document.querySelector('.sparky-app')?.classList
    appClassList?.add('sparky-app-bar-z-0')
    return () => {
      appClassList?.remove('sparky-app-bar-z-0')
    }
  }, [])
  useEffect(() => {
    const newState = getUpdatedState(auth, stateRef)
    if (!newState.loading) {
      updateStateProps(newState)
    }
  }, [auth])
  if (state.loading) {
    return <LoadingPlaceholder />
  }
  return (
    <div className='cm-px-20 cm-w-[100vw]'>
      <div className='cm-flex cm-mt-28 cm-flex-1 cm-flex-col cm-px-20 cm-items-center'>
        <ScreenHeader title={'Activate Subscriptions based on Deployment Profile(s)'}></ScreenHeader>
        <ProfileActivationForm state={state} primaryButton={{
          text: 'Activate Now'
        }} ></ProfileActivationForm>
      </div>
    </div>
  )
}
export default ProfileActivationContainer
